import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useOrg } from '../../contexts/OrgContext';
import Sidebar from './Sidebar';
import Header from './Header';
import BottomTabBar from './BottomTabBar';
import FloatingActionButton from './FloatingActionButton';
import Disclaimer from './Disclaimer';
import { Toaster } from '../ui/sonner';
import NpsPrompt from '../NpsPrompt';
import { useFeatureTracker } from '../FeatureTracker';

export default function AppLayout() {
  const { isAuthenticated, loading } = useAuth();
  const { org, loading: orgLoading } = useOrg();
  useFeatureTracker();

  if (loading || orgLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFDFD]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-[#D94E18] border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-zinc-500">Loading...</p>
        </div>
        <Toaster position="top-right" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to onboarding if not completed
  if (org && !org.onboarding_complete) {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <div className="flex min-h-screen bg-[#FDFDFD]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 p-4 md:p-6 lg:p-8 pb-20 md:pb-8 overflow-x-hidden">
          <Outlet />
        </main>
        <Disclaimer />
      </div>
      <FloatingActionButton />
      <BottomTabBar />
      <Toaster position="top-right" />
      <NpsPrompt />
    </div>
  );
}
